<template>
  <div class="attendees-messages-details">
    <v-btn
      icon
      light
      @click.native='closeModal'
      class="close-button"
    >
      <v-icon class="close-icon">close</v-icon>
    </v-btn>
    <v-card ma-2 class="elevation-4">
      <v-flex pa-3 justify-center>
        <h2>Message Details</h2>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Receiver Email</h3>
        <p>{{details.receiverEmail}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Sender Email</h3>
        <p>{{details.senderEmail}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>First Name</h3>
        <p>{{details.senderFirstName}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Last Name</h3>
        <p>{{details.senderLastName}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Company</h3>
        <p>{{details.senderCompany}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Job Title</h3>
        <p>{{details.senderJobTitle}}</p>
      </v-flex>
      <v-flex px-3 py-1>
        <h3>Message</h3>
        <p>{{details.message}}</p>
      </v-flex>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'attendees-messages-details',
    props: {
      details: {
        required: true,
        type: Object
      }
    },
    methods: {
      closeModal () {
        this.$emit('closeModal')
      }
    }
  }
</script>

<style scoped>
  .attendees-messages-details {
    position: relative;
  }

  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .close-icon {
    z-index: 50;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Registration/Attendee/AttendeesMessages/attendeesMessagesDetails.vue